import { render, staticRenderFns } from "./agenda-geral-item.vue?vue&type=template&id=5c002edd&"
import script from "./agenda-geral-item.vue?vue&type=script&lang=js&"
export * from "./agenda-geral-item.vue?vue&type=script&lang=js&"
import style0 from "./agenda-geral-item.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports